// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","introRequestWrapper":"_1Dnrx2VHCSVrkIYIGP-tmo","declinedRequestWrapper":"_2vODYz4Fiy5nii3OnQxzK_"};